<template>
  <li
    class="nav-item px-2 text"
    style="text-align: left"
    :class="{ 'menu-open': seccion_actual == 'administracion' }"
  >
    <a href="#" class="nav-link">
      <i class="nav-icon fas fa-user-cog"></i>
      <p>Administración<i class="fas fa-angle-left right"></i></p>
    </a>

    <ul class="nav nav-treeview">

      <!-- Mantenedor Regional -->
      <li class="nav-item" v-if="showMantenedorRegional">
        <router-link
          class="nav-link"
          to="/superadministrador/mantenedor_regional"
        >
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Mantenedor Regional</p>
        </router-link>
      </li>


      <!-- Clientes -->
      <li class="nav-item" v-if="showEmpresas">
        <router-link class="nav-link" to="/administracion/clientes">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Clientes</p>
        </router-link>
      </li>

      <!-- Usuarios -->
      <li class="nav-item" v-if="showUsuarios">
        <router-link class="nav-link" to="/administracion/usuarios">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Usuarios</p>
        </router-link>
      </li>

      <!-- Proveedores -->
      <li class="nav-item" v-if="showProveedores">
        <router-link class="nav-link" to="/administracion/proveedores">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Proveedores</p>
        </router-link>
      </li>
      <li class="nav-item" v-if="showPuertosYPaises">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Puertos y Países<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">

          <!-- Puertos -->
          <li class="nav-item" v-if="showPuertos">
            <router-link class="nav-link" to="/administracion/puertos">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Puertos</p>
            </router-link>
          </li>
          
          <!-- Destinos -->
          <li class="nav-item" v-if="showDestinos">
            <router-link class="nav-link" to="/administracion/destinos">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Destinos</p>
            </router-link>
          </li>
        </ul>
      </li>



        <!-- Contenedores -->
      <li class="nav-item" v-if="showContenedores">
        <router-link class="nav-link" to="/administracion/contenedores">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Contenedores</p>
        </router-link>
      </li>
      
        <!-- Naves -->
      <li class="nav-item" v-if="showNaves">
        <router-link class="nav-link" to="/administracion/naves">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Naves</p>
        </router-link>
      </li>



      <li class="nav-item" v-if="showPalletsYDerivados">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Pallets y derivados<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">
          
          <!-- Pallets -->
          <li class="nav-item" v-if="showPallets">
            <router-link class="nav-link" to="/administracion/pallets">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Pallets</p>
            </router-link>
          </li>
          
          <!-- Condiciones -->
          <li class="nav-item" v-if="showCondiciones">
            <router-link class="nav-link" to="/administracion/condiciones">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Condiciones</p>
            </router-link>
          </li>
          

          
        </ul>
      </li>
      <!-- Navieras -->
      <li class="nav-item" v-if="showNavieras">
        <router-link class="nav-link" to="/administracion/navieras">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Navieras</p>
        </router-link>
      </li>

      <!-- Productos -->
      <li class="nav-item" v-if="showCategoriaProductos">
        <router-link class="nav-link" to="/administracion/categorias_productos">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Categorias Productos</p>
        </router-link>
      </li>

      <!-- Límite Planificaciones -->
      <li class="nav-item" v-if="showLimitePlanificaciones">
        <router-link
          class="nav-link"
          to="/administracion/tiempo_limite_de_planificaciones"
        >
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Límite Planificaciones</p>
        </router-link>
      </li>

      <!-- Temporadas -->
      <li class="nav-item" v-if="showTemporadas">
        <router-link class="nav-link" to="/administracion/temporadas">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Temporadas</p>
        </router-link>
      </li>

      <!-- Embarcador -->
      <li class="nav-item" v-if="showEmbarcador">
        <router-link class="nav-link" to="/administracion/embarcadores">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Embarcador</p>
        </router-link>
      </li>

      <!-- Extra costos / Recargos -->
      <li class="nav-item" v-if="showServiciosLogisticos">
        <a href="#" class="nav-link">
          <i class="nav-icon fas fa-circle text-xs"></i>
          <p>Servicios Logísticos<i class="fas fa-angle-left right"></i></p>
        </a>
        <ul class="nav nav-treeview">
          
          <!-- Tipos extra costos -->
          <li class="nav-item"  v-if="showServiciosLogisticosTipos">
            <router-link class="nav-link" to="/administracion/tipos_de_extra_costos">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Tipos de extra costos</p>
            </router-link>
          </li>
          
          <!-- Tipos extra costos -->
          <li class="nav-item" v-if="showServiciosLogisticosTiers">
            <router-link class="nav-link" to="/administracion/tiers">
              <i class="nav-icon far fa-circle text-xs"></i>
              <p>Tiers</p>
            </router-link>
          </li>
          
        </ul>
      </li>
    </ul>
  </li>
</template>

<script>
/**
 * @author Miguel González.
 * @description modify role structure. 
 * last modified 18-04-2023 17:25
 */
// Vuex
import { mapState } from "vuex";

export default {
  data() {
    return {
      current_url: "",
      showUsuarios: false,
      showClientes: false,
      showCategoriaProductos: false,
      showPuertosYPaises: false,
      showPuertos: false,
      showPaises: false,
      showDestinos: false,
      showContenedores: false, 
      showSubContenedores: false, 
      showDepositos: false,
      showAtmosferas: false,
      showTiposDeMovimiento: false,
      showZonasDeConsolidacion: false,
      showPalletsYDerivados: false,
      showPallets: false, 
      showEspecies: false,
      showCondiciones: false,
      showNaves: false,
      showEmpresas: false,
      showProveedores: false,
      showLimitePlanificaciones: false,
      showNavieras: false,
      showTemporadas: false,
      showEmbarcador: false,
      showDivisionTerritorial: false,
      showMantenedorRegional: false,

      showServiciosLogisticos : false
    };
  },
  computed: {
    ...mapState(["url_actual", "seccion_actual"]),
    ...mapState("seccionesAdministrador", [
      "isFiliales",
      "isClientes",
      "isUsuarios",
      "isRoles",
      "isProveedores",
      "isMantenedorRegional",
      "isPuertos",
      "isDestinos",
      "isContenedores",
      "isPallet",
      "isCondiciones",
      "isNaves",
      "isNavieras",
      "isProductos",
      "isLimitePlanificaciones",
      "isTemporadas",
      "isEmbarcador",
    ]),
  },
  methods: {
    superAdmin(){
      this.showClientes = true;
      this.showUsuarios = true;
      this.showCategoriaProductos = true;
      this.showPuertosYPaises = true;
      this.showPuertos = true;
      this.showPaises = true;
      this.showDestinos = true;
      this.showContenedores = true;
      this.showSubContenedores = true;
      this.showDepositos = true;
      this.showAtmosferas = true;
      this.showTiposDeMovimiento = true;
      this.showZonasDeConsolidacion = true;
      this.showPalletsYDerivados = true;
      this.showPallets = true;
      this.showEspecies = true;
      this.showCondiciones = true;
      this.showNaves = true;
      this.showEmpresas = true;
      this.showProveedores = true;
      this.showLimitePlanificaciones = true;
      this.showNavieras = true;
      this.showTemporadas = true;
      this.showEmbarcador = true;
      this.showDivisionTerritorial = true;
      this.showServiciosLogisticos = true;
      this.showServiciosLogisticosTipos = true;
      this.showServiciosLogisticosTiers = true;

    }
  },
  created(){
    if(JSON.parse(localStorage.getItem('user'))?.rol === 'Super Administrador') this.superAdmin();
    const administracionRoleStructure = JSON.parse(localStorage.getItem('roleStructure')).find(({idModule}) => idModule === 5);
    if ( administracionRoleStructure ) {
      administracionRoleStructure.sections.map(({ idSection, subSections }) => {
        switch (idSection) {
          case 6: this.showMantenedorRegional = true; break;
          case 3: this.showUsuarios = true; break;
          case 2: this.showClientes = true; break;
          case 221: this.showCategoriaProductos = true; break;
          case 220: 
            this.showPuertosYPaises = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 7: this.showPuertos = true; break;
                case 54: this.showPaises = true; break;
                case 8: this.showDestinos = true; break;
                default: break;
              }
            });
            break;
          case 9: 
            this.showContenedores = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 47: this.showSubContenedores = true; break;
                case 48: this.showDepositos = true; break;
                case 49: this.showAtmosferas = true; break;
                case 50: this.showTiposDeMovimiento = true; break;
                case 51: this.showZonasDeConsolidacion = true; break;
                default: break;
              }
            });
            break;
          case 218: 
            this.showPalletsYDerivados = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 10: this.showPallets = true; break;
                case 219: this.showEspecies = true; break;
                case 11: this.showCondiciones = true; break;
                case 12: this.showNaves = true; break;
                default: break;
              }
            });
            break;
          case 267: 
            this.showServiciosLogisticos = true;
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 268: this.showServiciosLogisticosTipos = true; break;
                case 269: this.showServiciosLogisticosTiers = true; break;
                default: break;
              }
            });
            break;
          case 222: this.showEmpresas = true; break;
          case 5: this.showProveedores = true; break;
          case 15: this.showLimitePlanificaciones = true; break;
          case 13: this.showNavieras = true; break;
          case 16: this.showTemporadas = true; break;
          case 17: this.showEmbarcador = true; break;
          case 223: this.showDivisionTerritorial = true; break;


          default:
            break;
        }
      });
    }

    const administracionUserStructure = JSON.parse(localStorage.getItem('userStructure')).find(({idModule}) => idModule === 5);
    if ( administracionUserStructure ) {
      administracionUserStructure.sections.map(({ idSection, subSections }) => {
        switch (idSection) {
          case 6: this.showMantenedorRegional = true; break;
          case 3: this.showUsuarios = true; break;
          case 2: this.showClientes = true; break;
          case 221: this.showCategoriaProductos = true; break;
          case 220: 
            this.showPuertosYPaises = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 7: this.showPuertos = true; break;
                case 54: this.showPaises = true; break;
                case 48: this.showDestinos = true; break;
                default: break;
              }
            });
            break;
          case 9: 
            this.showContenedores = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 47: this.showSubContenedores = true; break;
                case 48: this.showDepositos = true; break;
                case 49: this.showAtmosferas = true; break;
                case 50: this.showTiposDeMovimiento = true; break;
                case 51: this.showZonasDeConsolidacion = true; break;
                default: break;
              }
            });
            break;
          case 218: 
            this.showPalletsYDerivados = true; 
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 10: this.showPallets = true; break;
                case 219: this.showEspecies = true; break;
                case 11: this.showCondiciones = true; break;
                case 12: this.showNaves = true; break;
                default: break;
              }
            });
            break;
          case 222: this.showEmpresas = true; break;
          case 5: this.showProveedores = true; break;
          case 15: this.showLimitePlanificaciones = true; break;
          case 13: this.showNavieras = true; break;
          case 16: this.showTemporadas = true; break;
          case 17: this.showEmbarcador = true; break;
          case 223: this.showDivisionTerritorial = true; break;
          case 267: 
            this.showServiciosLogisticos = true;
            subSections.map(({ idSubsection }) => {
              switch (idSubsection) {
                case 268: this.showServiciosLogisticosTipos = true; break;
                case 269: this.showServiciosLogisticosTiers = true; break;
                default: break;
              }
            });
            break;

          default:
            break;
        }
      });
    }
  },
};
</script>
